import React from 'react';

import Arrows from '../../../assets/media/rotate-device/arrows.svg';
import Device from '../../../assets/media/rotate-device/device.svg';

import './style.scss';

interface RotateDeviceProps {

}

export const RotateDevice: React.FC<RotateDeviceProps> = () => {
  return (
    <div className="rotate-device-wr">
      <img src={Device} className="device fixed" alt="device" />
      <img src={Device} className="device rotate-device" alt="rotate-device" />
      <img src={Arrows} className="rotate-arrows" alt="rotate-arrows" />
    </div>
  );
};
